module.exports = __webpack_public_path__ + "img/5.2a5c7a95.jpg";